module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/butler-df78fa9fdface84e0aa61af02a264cf7.svg";